import { useEffect } from 'react';

const useUnhandledRejectionErrors = (handler: Handler) => {
  useEffect(() => {
    window.addEventListener('unhandledrejection', handler);

    return () => {
      window.removeEventListener('unhandledrejection', handler);
    };
  }, [handler]);
};

export default useUnhandledRejectionErrors;

type Handler = (event: PromiseRejectionEvent) => void;
